export default __webpack_public_path__ + "static/media/Addition.9e26ab66.svg";